import { selectOptionsToString as p, selectOptionToString as s } from "../options.js";
import "react";
import "@material-bank/ds-utils";
import { Text as c } from "../../../Typography/Text.js";
import { jsx as l } from "theme-ui/jsx-runtime";
const S = (e) => {
  const {
    selectedOption: t,
    placeholder: r,
    ...o
  } = e, i = !!t && (!Array.isArray(t) || t.length > 0), n = Array.isArray(t) ? p(t) : s(t);
  return /* @__PURE__ */ l(c, {
    inherit: !0,
    ...o,
    children: i ? n : r
  });
};
export {
  S as SelectValue
};
